import EnvironmentService from "../utilities/EnvironmentService";

export const LOGGING_APP_ID = "ramsey-network.streamingtv-web-app";

export const LOGGING_API_KEY = EnvironmentService.logging_api_key();
